import { InjectionToken } from "@angular/core";

export type ModalData<T = undefined> = {
  data: T;
};

export const MODAL_DATA = new InjectionToken('modal-data')
